import React from 'react';
import PropTypes from 'prop-types';
import DefaultCell from './DefaultCell';
import DefaultIndexCell from './DefaultIndexCell';
import StyledCell from './StyledCell';

const getClassName = count => {
  switch (count) {
    case 1: return '100%';
    case 2: return '50%';
    case 3: return '33.3%';
    case 4: return '25%';
    case 5: return '20%';
    default: return '0%';
  }
};

const CellContent = 
({
  cell, metricsList, metricsCount, newHighlightAndFilter, crosstabviewFlag, cellHeight,
  handleProbabilitiesEditClick }) => {
  const { sampleHighlight, sampleFilter, weightedHighlight, weightedFilter, verticalHighlight,
    verticalFilter, horizontalHighlight, horizontalFilter, indexHighlight, indexFilter,
    styleUpdated } = newHighlightAndFilter;
  const sampleBgColor = 'rgb(252, 218, 214)';
  const verticalBgColor = 'rgb(216, 239, 184)';
  const horizontalBgColor = 'rgb(255, 237, 177)';
  const weightedBgColor = 'rgb(207, 228, 249)';
  const rowData = cell.piv ? cell.rowData : undefined;
  const colData = cell.piv ? cell.colData : undefined;
  if (crosstabviewFlag) {
    const rowHeight = `${(parseInt(cellHeight, 10) / metricsCount) - 1}px`;
    return (
      <div className="c-table-crosstab-col-content" style={{ height: cellHeight }}>
        <div className="row-content" style={{ height: cellHeight }}>
          {metricsList[0] && <div className="row-value" style={{ height: rowHeight }}>
            {!styleUpdated && <DefaultCell
              bgColor={sampleBgColor}
              percent={`${cell.samplePerc}%`}
              value={cell.sample}
              height={rowHeight}
              crosstabviewFlag={crosstabviewFlag}
              rowData={rowData}
              colData={colData}
              handleProbabilitiesEditClick={handleProbabilitiesEditClick}
            />}
            {styleUpdated && <StyledCell
              filter={sampleFilter}
              highlight={sampleHighlight}
              value={cell.sample}
              height={rowHeight}
            />}
          </div>}
          {metricsList[1] && <div className="row-value" style={{ height: rowHeight }}>
            {!styleUpdated && <DefaultCell
              bgColor={weightedBgColor}
              percent={`${cell.weightedPerc}%`}
              value={cell.weighted}
              height={rowHeight}
              crosstabviewFlag={crosstabviewFlag}
              rowData={rowData}
              colData={colData}
              handleProbabilitiesEditClick={handleProbabilitiesEditClick}
            />}
            {styleUpdated && <StyledCell
              filter={weightedFilter}
              highlight={weightedHighlight}
              value={cell.weighted}
              height={rowHeight}
            />}
          </div>}
          {metricsList[2] && <div className="row-value" style={{ height: rowHeight }}>
            {!styleUpdated && <DefaultCell
              bgColor={verticalBgColor}
              percent={cell.vertical}
              value={cell.vertical}
              height={rowHeight}
              crosstabviewFlag={crosstabviewFlag}
              rowData={rowData}
              colData={colData}
              handleProbabilitiesEditClick={handleProbabilitiesEditClick}
            />}
            {styleUpdated && <StyledCell
              filter={verticalFilter}
              highlight={verticalHighlight}
              value={cell.vertical}
              height={rowHeight}
            />}
          </div>}
          {metricsList[3] && <div className="row-value" style={{ height: rowHeight }}>
            {!styleUpdated && <DefaultCell
              bgColor={horizontalBgColor}
              percent={cell.horizontal}
              value={cell.horizontal}
              height={rowHeight}
              crosstabviewFlag={crosstabviewFlag}
              rowData={rowData}
              colData={colData}
              handleProbabilitiesEditClick={handleProbabilitiesEditClick}
            />}
            {styleUpdated && <StyledCell
              filter={horizontalFilter}
              highlight={horizontalHighlight}
              value={cell.horizontal}
              height={rowHeight}
            />}
          </div>}
          {metricsList[4] && <div className="row-value" style={{ height: rowHeight }}>
            {!styleUpdated && <DefaultIndexCell
              title={cell.index}
              className={cell.indexClassName}
              value={cell.index}
              height={rowHeight}
              crosstabviewFlag={crosstabviewFlag}
              rowData={rowData}
              colData={colData}
              handleProbabilitiesEditClick={handleProbabilitiesEditClick}
            />}
            {styleUpdated && <StyledCell
              filter={indexFilter}
              highlight={indexHighlight}
              value={cell.index}
              height={rowHeight}
            />}
          </div>}
        </div>
      </div>
    );
  }
  return (
    <div className="c-table--col">
      <div className="cell-content" style={{ height: cellHeight }}>
        {metricsList[0] && <div className="cell-value" style={{ width: getClassName(metricsCount), display: 'flex', alignItems: 'center' }}>
          {!styleUpdated && <DefaultCell
            bgColor={sampleBgColor}
            percent={`${cell.samplePerc}%`}
            value={cell.sample}
            rowData={rowData}
            colData={colData}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />}
          {styleUpdated && <StyledCell
            filter={sampleFilter}
            highlight={sampleHighlight}
            value={cell.sample}
          />}
        </div>}
        {metricsList[1] && <div className="cell-value" style={{ width: getClassName(metricsCount), display: 'flex', alignItems: 'center' }}>
          {!styleUpdated && <DefaultCell
            bgColor={weightedBgColor}
            percent={`${cell.weightedPerc}%`}
            value={cell.weighted}
            rowData={rowData}
            colData={colData}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />}
          {styleUpdated && <StyledCell
            filter={weightedFilter}
            highlight={weightedHighlight}
            value={cell.weighted}
          />}
        </div>}
        {metricsList[2] && <div className="cell-value" style={{ width: getClassName(metricsCount), display: 'flex', alignItems: 'center' }}>
          {!styleUpdated && <DefaultCell
            bgColor={verticalBgColor}
            percent={cell.vertical}
            value={cell.vertical}
            rowData={rowData}
            colData={colData}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />}
          {styleUpdated && <StyledCell
            filter={verticalFilter}
            highlight={verticalHighlight}
            value={cell.vertical}
          />}
        </div>}
        {metricsList[3] && <div className="cell-value" style={{ width: getClassName(metricsCount), display: 'flex', alignItems: 'center' }}>
          {!styleUpdated && <DefaultCell
            bgColor={horizontalBgColor}
            percent={cell.horizontal}
            value={cell.horizontal}
            rowData={rowData}
            colData={colData}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />}
          {styleUpdated && <StyledCell
            filter={horizontalFilter}
            highlight={horizontalHighlight}
            value={cell.horizontal}
          />}
        </div>}
        {metricsList[4] && <div className="cell-value" style={{ width: getClassName(metricsCount), display: 'flex', alignItems: 'center' }}>
          {!styleUpdated && <DefaultIndexCell
            className={cell.indexClassName}
            title={cell.index}
            value={cell.index}
            rowData={rowData}
            colData={colData}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />}
          {styleUpdated && <StyledCell
            filter={indexFilter}
            highlight={indexHighlight}
            value={cell.index}
          />}
        </div>}
      </div>
    </div>
  );
};

CellContent.propTypes = {
  cell: PropTypes.shape({}),
  highlightAndFilter: PropTypes.shape({
    sample: PropTypes.shape({}),
    weighted: PropTypes.shape({}),
    vertical: PropTypes.shape({}),
    horizontal: PropTypes.shape({}),
    index: PropTypes.shape({}),
  }),
  metricsList: PropTypes.arrayOf(PropTypes.bool),
  metricsCount: PropTypes.number,
  crosstabviewFlag: PropTypes.bool,
  newHighlightAndFilter: PropTypes.shape({}),
  handleProbabilitiesEditClick: PropTypes.func,
};

export default CellContent;
